import { SET_MINIMIZE_ART_WALL_PRODUCT_SIDEBAR } from './../const';

export default (minimizeArtWallProductSidebar) => {
  return {
    type: SET_MINIMIZE_ART_WALL_PRODUCT_SIDEBAR,
    minimizeArtWallProductSidebar: minimizeArtWallProductSidebar
  }
};
